import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Pertanyaan {
  nama_pelanggan: string;
  email_pelanggan: string;
  whatsapp_number: string;
  negara: string;
  trip_kategori: string;
  destinasi: string;
  start_date: string;
  end_date: string;
  inquiry?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PertanyaanService {

  private apiUrl = `${environment.apiUrl}`;
  constructor(private http: HttpClient) {}


   // Simpan pesan & kirim email
  simpanPesan(data: Pertanyaan): Observable<any> {
    return this.http.post(`/api/pertanyaan`, data);
  }

  // Kirim ulang email
  kirimPesanUlang(data: Pertanyaan): Observable<any> {
    return this.http.post(`/api/pertanyaan/kirim`, data);
  }

  // Hapus pesan berdasarkan ID
  hapusPesan(id: number): Observable<any> {
    return this.http.delete(`/api/pertanyaan/${id}`);
  }
}
